module.exports = __webpack_public_path__ + "static/media/Boreal-Besties2.9949d2bb.jpg";